import React from 'react'
import PropTypes from 'prop-types'
import { SELECTABLE_MEMBERSHIP_TYPES, ProductPrices } from 'types'
import exact from 'prop-types-exact'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { selectors as memberSelectors } from 'member-reducer'
import * as memberActions from 'member-actions'
import { MembershipTypeForm } from 'member-portal/forms'
import { ProductPricesUnavailable } from 'member-portal/components'
import { makeMemberApplicationPath, PATH } from 'config'
import { getTrailerCareByMembershipType } from 'utils'

const propTypes = {
  setSelectedMembershipType: PropTypes.func.isRequired,
  setSelectedTrailerCareType: PropTypes.func.isRequired,
  selectedMembershipType: PropTypes.string.isRequired,
  membershipPrices: ProductPrices.isRequired,
}

function AllMembershipTypes({
  setSelectedMembershipType,
  setSelectedTrailerCareType,
  selectedMembershipType,
  membershipPrices,
}) {
  const history = useHistory()

  // A partial catalog means /products came back incomplete, so block the whole
  // picker and ask for a refresh rather than listing a card with an "N/A" price.
  if (
    SELECTABLE_MEMBERSHIP_TYPES.some((type) => membershipPrices[type] == null)
  ) {
    return <ProductPricesUnavailable />
  }

  return (
    <>
      <section className="form-block-container">
        <header className="header-title">
          <h1>Sea Tow Membership Options</h1>
        </header>
        <div className="card card-medium">
          <div className="card-inner">
            <div className="form-block">
              <MembershipTypeForm
                initialValues={{ selectedMembershipType }}
                membershipPrices={membershipPrices}
                onSubmit={({ selectedMembershipType }) => {
                  setSelectedMembershipType(selectedMembershipType)
                  setSelectedTrailerCareType(
                    getTrailerCareByMembershipType(selectedMembershipType),
                  )
                }}
                onSubmitSuccess={() =>
                  history.push(
                    makeMemberApplicationPath(PATH.MEMBERSHIP_TYPE_SELECTED),
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

AllMembershipTypes.propTypes = exact(propTypes)

function mapStateToProps(state) {
  return {
    selectedMembershipType: memberSelectors.selectedMembershipType(state),
    membershipPrices: memberSelectors.membershipPrices(state),
  }
}

const mapDispatchToProps = {
  setSelectedMembershipType: memberActions.setSelectedMembershipType,
  setSelectedTrailerCareType: memberActions.setSelectedTrailerCareType,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AllMembershipTypes,
)
